export const getUserRoles = roles => {
  if (!roles?.length) return null;
  return roles.map(item => item.name);
};

export const includesRole = (rules, roles) => {
  if (!rules?.length || !roles?.length) return false;

  const rulesSet = new Set(rules);

  return (roles ?? []).some(role => rulesSet.has(role));
};

export const hasPermission = (requiredPermissions, userPermissions) =>
  requiredPermissions.some(permission => !!userPermissions?.includes(permission));
